import React from 'react';

import { VideoSkeleton } from 'src/registry/ui/Skeleton';

type VideoProps = {
    loading: boolean;
    videoRef: React.RefObject<HTMLVideoElement | null>;
};

const Video = ({ loading, videoRef }: VideoProps) => {
    return (
        <div className="relative aspect-video w-full rounded-xl">
            <video ref={videoRef} autoPlay muted playsInline className="aspect-video max-h-full max-w-full" />
            {loading && <VideoSkeleton className="absolute top-0 left-0 size-full" />}
        </div>
    );
};

export default Video;
